export default __webpack_public_path__ + "images/onboarding/shapes-7552d0c46089272870a1551a814c629f.svg";